{
  "menu": {
    "login": "Kirjaudu sisään",
    "logout": "Kirjaudu ulos",
    "support": "Asiakastuki"
  },
  "applicationSummary": {
    "companyNameLabel": "Yritys",
    "change": "Vaihda hakemusta"
  },
  "applicationSelector": {
    "choose": "Valitse",
    "cancel": "Peru"
  },
  "login": {
    "identificationSuccessful": "Sinut on nyt tunnistettu"
  },
  "eligibilityCheckForm": {
    "heading": "Tarkista yrityksesi lainamahdollisuudet",
    "checkYourEligibility": "Näe mahdollisuudet"
  },
  "preliminaryBidForm": {
    "preliminaryBidHeading": "Arvioi luottorajasi",
    "estimateLimitWithoutCreditCheck": "Arvioi luottorajasi",
    "estimateLimit": "Arvioi luottorajasi",
    "loadingText": "Arvioidaan kuinka paljon voit saada lainaa...",
    "loadingTextEligibilityCheck": "Arvioidaan mahdollisuutesi saada lainaa...",
    "weEstimateThatCompanyCanReceive": "Arvioimme, että {{organisationName}} voi saada lainaa noin ",
    "immediateResponse": "Näet vastauksen heti",
    "immediateResponseWithoutCreditCheck": "Näet vastauksen heti, ilman luottotietojen tarkistusta"
  },
  "delegatedInformationPage": {
    "heading": "Sinut on kutsuttu lisäämään tietoja",
    "description": "on pyytänyt sinua lisäämään tietoja yrityksen rahoitushakemuksen yhteydessä"
  }
}
